export const volumeUnitsEnum = {
  m3: 'm3',
  litres: 'litres',
} as const

export type VolumeUnitsEnum = (typeof volumeUnitsEnum)[keyof typeof volumeUnitsEnum]

export type VolumeUnits = VolumeUnitsEnum